import tingle from 'tingle.js';
export class ProductImages {

    constructor() {
        this.trigger = document.querySelector('.open-image-modal');
        this.imageContainer = document.getElementById('productimages');

        if(this.trigger) {
            this.initialiseModal();
        }
    }

    initialiseModal() {
    	
        this.modal = new tingle.modal({
            stickyFooter: false,
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: "Close",
            cssClass: ['images-modal'],
            onOpen: function() {
                let close = document.querySelector('.tingle-modal-box .close');
                close.addEventListener('click', ()=>{
                    this.close();
                });
            },
            onClose: function() {},
            beforeClose: function() {
                return true;
            }
        });
        this.modal.setContent(this.imageContainer.innerHTML);
        this.trigger.addEventListener('click', (event)=>{
            event.preventDefault();
            
            jQuery('.images-modal  .image-wrap a, .images-modal  .image-wrap img').remove();
            jQuery('#productimages .image-wrap a, #productimages .image-wrap img').remove();
            jQuery('.images-modal  .image-wrap, #productimages .image-wrap').each(function() {
		var url = jQuery(this).find('div').attr('data-image');
		jQuery(this).append('<a href="'+url+'" target="_blank" rel="nofollow"></a>');
		jQuery(this).append('<img src="'+url+'" alt="">');
            });
            
            this.modal.open();
        });
    }

}


// WEBPACK FOOTER //
// ./assets/sass/product/product-images.js